// #region Dependencias
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { colors } from 'components/Library/theme'
import { IDIOMAS } from 'utils/constants'
// #endregion

// #region Estilos
const StyledInputContainer = styled.div.attrs((props) => ({
  style: {
    backgroundColor:
      props.color === 'primary'
        ? colors.primary
        : props.color === 'secondary'
          ? colors.secondary
          : props.color === 'tertiary'
            ? colors.tertiary
            : props.color === 'dark'
              ? colors.text
              : props.color,
    borderRadius: `${props.borderradius}rem`
  }
}))`
  margin: 1rem;
  opacity: 0.75;
  padding: 0.5rem;
  position: ${({ modoEdicion }) => (modoEdicion ? 'absolute' : 'fixed')};
  left: 0;
  bottom: 0;
  z-index: 100;
`

const StyledSelect = styled.select`
  background-color: transparent;
  border: 0;
  color: ${colors.white};
  cursor: pointer;
  font-size: 1rem;
  outline: none;
`

const StyledOption = styled.option`
  color: ${colors.text};
`
// #endregion

/**
 * Componente para manejar el cambio de idiomas de la aplicación.
 *
 * @class
 */
const LanguageSelector = ({ modoEdicion, idiomas, color, borderradius }) => {
  const { i18n } = useTranslation()

  /**
   * Función para manejar el cambio de idioma mediante la acción {@link setIdioma}.
   * @param {Event} e - Evento de cambio de idioma.
   */
  const handleChangeIdioma = (e) => {
    const { value: nuevoIdioma } = e.target
    i18n.changeLanguage(nuevoIdioma)
  }

  useEffect(() => {
    if (idiomas.length === 1) {
      i18n.changeLanguage(idiomas[0])
    }
  }, [idiomas])

  if (idiomas.length > 1) {
    return (
      <StyledInputContainer
        modoEdicion={modoEdicion}
        borderradius={borderradius}
        color={color}
      >
        <StyledSelect
          id="idiomas"
          name="idiomas"
          value={i18n.language}
          onChange={handleChangeIdioma}
        >
          {idiomas.map((idioma, index) => (
            <StyledOption key={index} value={idioma}>
              {IDIOMAS.find((i) => i.value === idioma)?.label}
            </StyledOption>
          ))}
        </StyledSelect>
      </StyledInputContainer>
    )
  }
}

export default LanguageSelector
